// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginForm from './loginform';  
import Dashboard from './Dashboard';  
import RM from './RM'; 
import FM from './FM'; 
import PR from './PR'; 
import Profile from './Profile';  
import Logout from './Logout';  

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/webwork_node" element={<LoginForm />} />
        <Route path="/webwork_node/Dashboard" element={<Dashboard />} />
        <Route path="/webwork_node/RM" element={<RM />} />
        <Route path="/webwork_node/FM" element={<FM />} />
        <Route path="/webwork_node/PR" element={<PR />} />
        <Route path="/webwork_node/Profile" element={<Profile />} />
        <Route path="/webwork_node/Logout" element={<Logout />} />
      </Routes>
    </Router>
  </React.StrictMode>
);

